export default __webpack_public_path__ + "static/media/educating.2e44ff35.png";